import type { CSSProperties, InputHTMLAttributes, ReactNode } from 'react';
import { Search } from 'lucide-react';

/** Inline filter row: search first, then filters, then a right-aligned summary. */
export function FilterBar({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={['ui-filterbar', className].filter(Boolean).join(' ')} style={style}>
      {children}
    </div>
  );
}

export function FilterSearch(props: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div className="ui-filterbar-search">
      <Search />
      <input type="search" {...props} />
    </div>
  );
}

export function FilterSpacer() {
  return <div className="ui-filterbar-spacer" />;
}

export function FilterSummary({ children }: { children: ReactNode }) {
  return <span className="ui-filterbar-summary">{children}</span>;
}
